import React, { FC } from 'react';
import NewSelect from 'components/UI/NewSelect';
import {
  IReportBuilderFormik,
  TSelectOptionsType,
  TCurrentFilterType,
  TGroupingItem,
} from 'domains/ReportBuilder/types';
import { customFormikSetField } from 'domains/ReportBuilder/utils';
import { FormikProps } from 'formik';
import { checkedLocalization } from 'utils/checkedLocalization';

interface IRenderCatalogGroupingProps {
  item: TGroupingItem;
  currentValue: TCurrentFilterType | null;
  formikKey: keyof IReportBuilderFormik['reportFilters'];
  currentKey: string;
  setFieldValue: FormikProps<IReportBuilderFormik>['setFieldValue'];
}

export const RenderCatalogGrouping: FC<IRenderCatalogGroupingProps> = ({
  item,
  currentValue,
  formikKey,
  currentKey,
  setFieldValue,
}) => {
  const { data, label } = item;
  const selectOptionsData = data as TSelectOptionsType[];
  const selectOptionsValue =
    currentValue as unknown as TSelectOptionsType | null;

  const translateLabel = checkedLocalization(
    `reportbuilder.groupings.${label}`,
    label,
    false,
  );
  const trabslateSelectValue = selectOptionsValue
    ? {
        label: checkedLocalization(
          `reportbuilder.groupings.${selectOptionsValue.label}`,
          selectOptionsValue.label,
          false,
        ),
        value: selectOptionsValue.value,
      }
    : null;

  return (
    <NewSelect
      key={`${label}-${String(formikKey)}-${currentKey}`}
      selectAttributes={{
        options: selectOptionsData,
        value: trabslateSelectValue,
      }}
      onCustomChange={(value: string) => {
        customFormikSetField<IReportBuilderFormik>(
          selectOptionsData as unknown as Record<string, string>[],
          setFieldValue,
          `reportFilters.${formikKey}.${currentKey}`,
          value,
        );
      }}
      viewStyle="Vertical"
      label={translateLabel}
    />
  );
};
